<template>
    <v-container id="footer-menu-services-wrapper" class="pa-0" fluid>
        <v-row column>
            <v-col cols="12">
                <h3 class="uppercase widget-heading--footer">
                    <TranslatableStringComponent :tstring="{string: 'companyServices'}" />
                </h3>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
                <v-list>
                    <v-list-item
                        v-for="menuItem in menu.menuItems"
                        :key="menuItem._key"
                        class="footer-list-item"
                    >
                        <v-list-item-content>
                            <!-- <pre>{{ menuItem }}</pre> -->
                            <a
                                v-if="isExternal(menuItem, $i18n.locale)"
                                :href="menuItem.menuItemURLo[$i18n.locale]"
                                class=""
                            >
                                {{ menuItem.menuItemLabel[$i18n.locale] }}
                            </a>
                            <nuxt-link
                                v-else-if="isInternal(menuItem, $i18n.locale)"
                                :to="getCustomLocalePath(menuItem)"
                                nuxt
                                exact
                                class=""
                            >
                                <span>{{
                                    menuItem.menuItemLabel[$i18n.locale]
                                }}</span>
                            </nuxt-link>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import menuUtilities from '~/mixins/menuUtilities'
export default {
    name: 'MenuFooterServices',
    mixins: [menuUtilities]
}
</script>
